import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { CenterFrameLayout } from 'Layouts';
import { signOut } from 'State/User/UserActions';
import { handleSignOut } from 'Utils/MVPD';
import { segmentTrackEvent, tealiumTrackEvent, TRACKING_ENUMS } from 'Utils/Analytics';
import { logger } from 'Utils/Logger';
import { setLocation } from 'Utils/Path';

export function SignOutContainer() {
  const dispatch = useDispatch();
  const [path, setPath] = useState('');
  const { hasMvpd } = useSelector((s) => s.user);
  const { defaultConfig } = useSelector((s) => s.appConfig);
  const { rootDomain } = defaultConfig;

  useEffect(() => {
    async function logout() {
      logger.started('signout');
      segmentTrackEvent(TRACKING_ENUMS.EVENT_LOGOUT_STARTED);
      tealiumTrackEvent(TRACKING_ENUMS.EVENT_LOGOUT);
      try {
        await handleSignOut({ hasMvpd, profileSignOut: () => dispatch(signOut()) });
        segmentTrackEvent(TRACKING_ENUMS.EVENT_LOGOUT_COMPLETED);
        segmentTrackEvent(TRACKING_ENUMS.EVENT_PROFILE_LOGGED_OUT);
      } catch (error) {
        logger.error('signout', error);
      }

      // set redirect path
      const returnToParams = window.location.href.split('return_to=');
      let path = returnToParams[1] || rootDomain;
      if (returnToParams.length > 2) {
        path += `return_to=${returnToParams[2]}`;
      }
      const isExternalLink = !!path.match(/http/i);

      if (isExternalLink || path === rootDomain) {
        setLocation(path);
      } else {
        setPath(path);
      }
    }
    logout();
  }, [dispatch, rootDomain, hasMvpd]);

  // for internal non-http and rootDomain routes. e.g: signUpStart route no reload required
  if (path) {
    return <Navigate replace to={path} />;
  }

  return <CenterFrameLayout title="Signing out..." showLoader />;
}
